
import { Vue, Component, Prop, Watch, VModel } from 'vue-property-decorator'
import { Debounce } from 'lodash-decorators'
import { deserialise } from 'kitsu-core'

import { getRequest } from '@/plugins/api-axios'
import { getURL } from '@/utils/axios'

import UserAvatar from '@/views/Project/Observation/components/userAvatar.vue'
@Component({
    components: { UserAvatar },
})
export default class UserAutocomplete extends Vue {
    @VModel() selected!:
        | null
        | string
        | Record<string, any>
        | Array<Record<string, any>>
        | Array<string>
    @Prop({ default: false }) returnObject!: boolean
    @Prop({ default: false }) multiple!: boolean

    @Prop({ required: false }) disabled!: boolean
    @Prop({ required: true }) customFilterName!: string
    @Prop({ required: true }) customFilterId!: string
    @Prop({ required: true }) itemType!: string
    @Prop({ default: false }) clearable!: boolean
    @Prop({ default: true }) closeMenuOnClick!: boolean

    observationUrl = process.env.VUE_APP_OBSERVATIONS_BASE_URL
    userUrl = process.env.VUE_APP_USER_BASE_URL

    userMenu = false
    userMenuInitiated = false
    userLoading = false
    searchTerm: string | null = ''
    limit = 10
    offset = 0
    infiniteId = crypto['randomUUID']()

    users: Array<any> = []

    // Array to store full user info on selected if selected is not full object
    locallySelected: Array<any> = []

    get selectedObjects() {
        // If this component returns id string FE first need to look up full user value
        if (!this.returnObject) return []

        if (this.lodash.isArray(this.selected)) {
            return this.selected
        } else if (this.selected) {
            return [this.selected]
        }
        return []
    }

    get allUsers() {
        return this.lodash.unionBy(
            [...this.selectedObjects, ...this.locallySelected, ...this.users],
            'id'
        )
    }

    filterUserByName(name: string) {
        return name
            ? name?.toLowerCase()?.includes(this.searchTerm ? this.searchTerm.toLowerCase() : '')
            : true
    }

    userComparator(currentVal: any, itemVal: any) {
        let res = false
        if (this.lodash.isArray(currentVal)) {
            res =
                currentVal.findIndex((item) =>
                    this.returnObject ? item?.id == itemVal.id : item == itemVal
                ) > -1
        } else {
            res = this.returnObject ? currentVal?.id == itemVal.id : currentVal == itemVal
        }
        return res
    }

    // User search
    async searchUsersInObservations($state = null as any) {
        if (this.userMenuInitiated) {
            this.userLoading = true

            const { data } = await getRequest(
                getURL({
                    path: `users`,
                    base: this.observationUrl,
                    params: {
                        skipLinks: '',
                        'filter[kind]': 'normal',
                        [this.customFilterName]: this.customFilterId,
                        'page[limit]': this.limit,
                        'page[offset]': this.offset,
                        ...(this.searchTerm &&
                            this.searchTerm.length > 1 && {
                                'filter[searchTerm]': this.searchTerm,
                            }),
                    },
                })
            )

            const newUsers = deserialise(data).data
            this.offset += this.limit

            if ($state) {
                if (newUsers.length == this.limit) {
                    $state.loaded()
                } else {
                    $state.complete()
                }
            }

            this.users = [...this.users, ...newUsers]

            this.userLoading = false
        }
    }

    async searchUsersInUsers(ids: any) {
        if (ids.length == 0) return
        this.userLoading = true

        const { data } = await getRequest(
            getURL({
                path: `users`,
                base: this.userUrl,
                params: {
                    skipLinks: '',
                    'filter[id]': ids.join(','),
                    'page[limit]': ids.length,
                },
            })
        )

        this.locallySelected = deserialise(data).data
        this.userLoading = false
    }

    clearSelected() {
        this.selected = this.multiple ? [] : null
    }

    // States
    @Watch('userMenu')
    initiateSearch() {
        if (this.userMenu && !this.userMenuInitiated) {
            this.userMenuInitiated = true
            this.searchUsersInObservations()
            this.infiniteId = crypto['randomUUID']()
        }
    }

    @Watch('searchTerm')
    initLoading() {
        this.userLoading = true
    }

    @Debounce(500)
    @Watch('searchTerm')
    async initSearch() {
        this.offset = 0
        this.users = []
        this.infiniteId = crypto['randomUUID']()
    }

    async mounted() {
        if (!this.returnObject) {
            if (!this.selected) return

            await this.searchUsersInUsers(
                this.lodash.isArray(this.selected) ? this.selected : [this.selected]
            )
        }
    }
}
